import React from "react";
import { Button } from "./ui/button";
import { Inbox } from "lucide-react";

/**
 * Empty state reutilizável. Mostre quando a lista volta vazia.
 */
export function EmptyState({ icone: Icon = Inbox, titulo, descricao, acaoBotao, aoClicar }) {
  return (
    <div className="text-center py-14 px-4" data-testid="empty-state">
      <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-zinc-100 text-zinc-400 mb-3">
        <Icon className="w-7 h-7" />
      </div>
      <p className="text-sm font-medium text-zinc-700">{titulo}</p>
      {descricao && <p className="text-xs text-zinc-500 mt-1 max-w-sm mx-auto">{descricao}</p>}
      {acaoBotao && (
        <Button onClick={aoClicar} className="mt-4 bg-orange-600 hover:bg-orange-700 text-white" size="sm">
          {acaoBotao}
        </Button>
      )}
    </div>
  );
}

/**
 * Skeleton de tabela para usar durante loading.
 */
export function SkeletonTabela({ linhas = 8, colunas = 5 }) {
  return (
    <div className="w-full divide-y divide-zinc-100" data-testid="skeleton-tabela">
      {Array.from({ length: linhas }).map((_, i) => (
        <div
          key={i}
          className="grid gap-3 py-3 px-4"
          style={{ gridTemplateColumns: `repeat(${colunas}, 1fr)`, opacity: 1 - i * 0.06 }}
        >
          {Array.from({ length: colunas }).map((_, j) => (
            <div
              key={j}
              className="h-3.5 rounded bg-zinc-100 animate-pulse"
              style={{ width: j === 0 ? "80%" : j === colunas - 1 ? "50%" : "70%" }}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
